import { render, staticRenderFns } from "./BaseEchart.vue?vue&type=template&id=495a8252&scoped=true"
import script from "./BaseEchart.vue?vue&type=script&lang=js"
export * from "./BaseEchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a8252",
  null
  
)

export default component.exports